import * as CurrentActionTypes from '../../types/current';
import * as CollaboratorsSelectors from '../../selectors/collaborators';

/**
 * Sets the current user id
 * @param {number} payload current user id
 */
export const setCurrentUserId = (id) => ({
    type: CurrentActionTypes.SET_CURRENT_USER_ID,
    payload: id
});

/**
 * Sets the current collaborator id
 * @param {string} payload current collaborator id
 */
export const setCurrentCollaboratorId = (id) => ({
    type: CurrentActionTypes.SET_CURRENT_COLLABORATOR_ID,
    payload: id
});

/**
 * Sets the current file id
 * @param {string} payload current file id
 */
export const setCurrentFileId = (id) => ({
    type: CurrentActionTypes.SET_CURRENT_FILE_ID,
    payload: id
});

/**
 * Sets the current filerr id
 * @param {string} payload current filerr id
 */
export const setCurrentFilerrId = (id) => ({
    type: CurrentActionTypes.SET_CURRENT_FILERR_ID,
    payload: id
});

/**
 * Sets the current group id
 * @param {string} payload current group id
 */
export const setCurrentGroupId = (id) => ({
    type: CurrentActionTypes.SET_CURRENT_GROUP_ID,
    payload: id
});

/**
 * Sets the current comment id
 * @param {string} payload current comment id
 */
export const setCurrentCommentId = (id) => ({
    type: CurrentActionTypes.SET_CURRENT_COMMENT_ID,
    payload: id
});

/**
 * Sets the current timecode
 * @param {number} payload current timecode
 */
export const setCurrentTimecode = (timecode) => ({
    type: CurrentActionTypes.SET_CURRENT_TIMECODE,
    payload: timecode
});

export const setCurrentGroupIdAndCurrentCollaboratorId = (groupId) => (dispatch, getState) => {
    dispatch(setCurrentGroupId(groupId));
    dispatch(setCurrentCollaboratorId(
        CollaboratorsSelectors.getCurrentCollaboratorIdByGroupId(getState(), groupId)
    ));
    dispatch(setCurrentCommentId(undefined));
    dispatch(setCurrentTimecode(undefined));
};
